import React from 'react';

const MinimalistPig = (props) => {
  const { radius } = props;

  return (
    
    <svg width={`${radius * 2}px`} height={`${radius * 2.15}px`} x={`-${radius}px`} y={`-${radius * 1.15}px`} viewBox="0 0 200 215" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Artboard">
            <g id="Group">
              <path d="M170,0 C142.385763,0 120,22.3857625 120,50 L170,50 L170,0 Z" id="Oval-2-Copy-2" fill="#D794AB"></path>
              <path d="M30,0 C57.6142375,0 80,22.3857625 80,50 L30,50 L30,0 Z" id="Oval-2-Copy-2" fill="#D794AB"></path>
              <circle id="Oval-4" fill="#FFC3D8" cx="100" cy="115" r="100"></circle>
            </g>
          </g>
        </g>
    </svg>
  )
}
export default MinimalistPig;

export function resize(props) {
  const {radius, minY} = props;

  return {
    ...props,
    minY: minY + radius * .15,
  };
}



// WEBPACK FOOTER //
// ./src/core/thematic/minimalist/pig.js